<template lang='pug' src='./custom-tile-repeater.pug'></template>

<script>
import RouterButton from 'components/block/block-router-button/block-router-button'
import FunctionButton2 from 'components/block/block-function-button-2/block-function-button-2'

export default {
  props: ['props'],
  components: {
    RouterButton,
    FunctionButton2
  },
  methods: {
    openModal () {
      this.$store.dispatch('VIEW_SHOWMODAL', true)
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-tile-repeater.vue?47f8c9ac